/**
 * Utility functions for handling scroll behavior
 */
// Store the scroll container reference
let scrollContainerRef: HTMLElement | null = null;
/**
 * Sets the scroll container for the application
 * This is used to ensure proper scrolling behavior in the application
 */
export const setScrollContainer = (container: HTMLElement): void => {
  scrollContainerRef = container;
};

/**
 * Scrolls to a specific element with smooth behavior
 * @param elementId - The ID of the element to scroll to
 */
export const scrollToElement = (elementId: string): void => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

/**
 * Disables scrolling on the body element
 * Useful for modals and other overlays
 */
export const disableBodyScroll = (): void => {
  document.body.style.overflow = 'hidden';
};

/**
 * Enables scrolling on the body element
 */
export const enableBodyScroll = (): void => {
  document.body.style.overflow = '';
};



/**
 * Scroll to top of the container
 */
export const scrollToTop = (options?: ScrollBehavior) => {
  if (scrollContainerRef) {
    scrollContainerRef.scrollTo({
      top: 0,
      behavior: options || 'smooth'
    });
  }
};
